
import SharePage from '@/components/share/SharePage';
import { shareTabConstant } from '@/constants/share';

export default {
    components: { SharePage },

    created() {
        this.shareTabConstant = shareTabConstant;
    }
}
